<mat-toolbar color="primary">
  <mat-toolbar-row>
    <!--  <span>HOME</span> -->
     <!-- <span><a href="/">HOME</a></span>
     <span class="spacer"></span>
     <a mat-button routerLink="/register">Register</a>
     <a mat-button routerLink="/login">Login</a> -->
     <a style = "font: 600 20px/32px Comic Sans MS, Comic Sans, cursive; padding:0" mat-flat-button routerLink='/' color="primary">
      <i style="padding: 3%;"><img src="assets\srd-soft-tech-logo.png"/></i> SRD SOFT TECH</a>
     <span class="spacer"></span>
     <a style = "font: 600 20px/32px Comic Sans MS, Comic Sans, cursive; padding-right: 1%; padding-bottom: 1%;" mat-flat-button routerLink='/' color="primary">About Us</a>
     <div>
      <mat-icon aria-hidden="false" routerLink='/' aria-label="Example home icon">home</mat-icon>
    </div>
  </mat-toolbar-row>
</mat-toolbar>


<div class="container">
  <app-carousel [slides]="slides"> <router-outlet ></router-outlet> </app-carousel>
</div>
<!-- <router-outlet></router-outlet> -->